import { createFileRoute } from '@tanstack/react-router';
import { FxSettingsPage } from '../features/settings/FxSettingsPage';

export const Route = createFileRoute('/settings/fx')({
  component: FxSettingsPage,
});
